/*
 * Purpose: Home SEO content — competitor comparison + semantic keywords for crawlers
 * Last modified: 2026-06-28 | Agent
 * Completeness: 94
 */
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { COMPETITOR_COMPARISON, COMPETITOR_KEYWORDS, SEO_SITE } from '@/lib/seoMeta';
import { APP_ROUTES } from '@/lib/appRoutes';
import { Button } from '@/components/ui/button';

export function HomeSeoSection() {
  return (
    <section
      className="relative z-10 w-full max-w-3xl mx-auto px-4 sm:px-6 pb-12 sm:pb-16 space-y-10"
      aria-labelledby="home-seo-heading"
    >
      <div className="text-center sm:text-left space-y-3">
        <h2 id="home-seo-heading" className="text-lg sm:text-xl font-semibold text-foreground">
          The Zapier, Make &amp; n8n alternative built for outcomes
        </h2>
        <p className="text-sm text-muted-foreground leading-relaxed">
          {SEO_SITE.brand} is outcome-driven workflow automation — not another Zapier clone or Make
          scenario editor. Describe what should happen; our AutoBlock Flow Composer plans blocks,
          resolves owned connectors, dry-runs with sample data, and presents one final panel for
          review before live execution.
        </p>
      </div>

      <div className="grid gap-3 sm:grid-cols-2">
        {COMPETITOR_COMPARISON.map((row) => (
          <article
            key={row.name}
            className="rounded-xl border border-border/60 bg-card/40 backdrop-blur-sm p-4 space-y-2"
          >
            <h3 className="text-sm font-semibold text-foreground">
              vs {row.name}
              {row.name === 'Make' ? ' (Integromat)' : ''}
            </h3>
            <p className="text-xs text-muted-foreground">
              <span className="text-foreground/80">Pain:</span> {row.pain}
            </p>
            <p className="text-xs text-muted-foreground flex gap-1.5">
              <CheckCircle2 className="h-3.5 w-3.5 shrink-0 text-[hsl(var(--ab-green-core))] mt-0.5" />
              <span>{row.autoblocks}</span>
            </p>
          </article>
        ))}
      </div>

      <div className="rounded-xl border border-border/50 bg-muted/30 p-4 sm:p-5 space-y-3">
        <h3 className="text-sm font-semibold text-foreground">Why teams switch from legacy automation</h3>
        <ul className="grid gap-2 sm:grid-cols-2 text-xs text-muted-foreground">
          {COMPETITOR_KEYWORDS.slice(0, 8).map((kw) => (
            <li key={kw} className="flex gap-1.5">
              <span className="text-[hsl(var(--ab-green-core))]">•</span>
              {kw}
            </li>
          ))}
        </ul>
        <div className="flex flex-wrap gap-2 pt-1">
          <Button size="sm" asChild>
            <Link to={APP_ROUTES.compose}>
              Start composing
              <ArrowRight className="h-3.5 w-3.5 ml-1" />
            </Link>
          </Button>
          <Button size="sm" variant="outline" asChild>
            <Link to={APP_ROUTES.help}>Migration guides</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
